// Version 3: Ereignisse für Google Tag Manager (window.dataLayer), ohne persönliche Daten.
// VERTRAG: track(event, params). Gehört Bau Agent B3.
// Ereignisse: form_submit, form_step, cta_click, phone_click, mail_click, file_upload, booking_click, whatsapp_click.
// Nur aus Komponenten von Version 3 aufrufen, Version 1 und 2 senden weiterhin nichts.

// Sicherheitsnetz: Felder, die Personendaten enthalten könnten, werden nie mitgeschickt
const BLOCKED = ["name", "firstName", "lastName", "email", "phone", "company", "message", "website", "file_names", "files"];

export const track = (event, params = {}) => {
    if (typeof window === "undefined" || !event) return;
    const clean = {};
    Object.entries(params || {}).forEach(([k, v]) => {
        if (BLOCKED.includes(k) || v === undefined) return;
        clean[k] = v;
    });
    try {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ event, ...clean });
    } catch {
        // Messung darf die Seite nie stören
    }
};

export default track;
